<template>
  <div class="button-video">
    <div class="button-video__aspect-ratio">
      <div class="button-video__background video-video-cta" />

      <div class="button-video__play picto-play" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonVideo',
};
</script>

<style lang="stylus" scoped>
.button-video {
  overflow: hidden;
  border-radius: 10px;
  border: 2px solid black;
  cursor: pointer;
}

.button-video__aspect-ratio {
  position: relative;

  box-sizing: border-box;
  width: 100%;
  height: 0;
  padding-bottom: (133 / 235) * 100%;
}

.button-video__background {
  position: absolute;

  width: 100%;
  height: 100%;

  background-size: 100% 100%;
}

.button-video__play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
